import { render, staticRenderFns } from "./modal_actualizar_formulario.vue?vue&type=template&id=5286bfb3&scoped=true&"
import script from "./modal_actualizar_formulario.vue?vue&type=script&lang=js&"
export * from "./modal_actualizar_formulario.vue?vue&type=script&lang=js&"
import style0 from "./modal_actualizar_formulario.vue?vue&type=style&index=0&id=5286bfb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5286bfb3",
  null
  
)

export default component.exports